import { render, staticRenderFns } from "./customer-address-modal-selector.vue?vue&type=template&id=f46d1d8c&"
import script from "./customer-address-modal-selector.vue.ts?vue&type=script&lang=ts&"
export * from "./customer-address-modal-selector.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports